var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSubtract = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10m1.163-11.578-1.252 5.882c-.088.425.037.666.38.666.242 0 .609-.088.858-.307l-.11.52c-.36.432-1.15.747-1.831.747-.88 0-1.253-.528-1.01-1.648l.922-4.336c.078-.366.007-.498-.359-.586l-.564-.103.103-.476zM10 7a1.25 1.25 0 1 1 0-2.5A1.25 1.25 0 0 1 10 7"
})));
export default SvgSubtract;